(() => {
  let isBackOrReloadNavigation = false;

  if (
    window.performance
    && window.performance.getEntriesByType
    && window.performance.getEntriesByType('navigation').length
    && ['back_forward', 'reload'].indexOf(window.performance.getEntriesByType('navigation')[0].type) > -1
  ) {
    isBackOrReloadNavigation = true;
    document.documentElement.classList.add('was-back-or-reload-navigated');

    window.setTimeout(() => {
      isBackOrReloadNavigation = false;
      document.documentElement.classList.remove('was-back-or-reload-navigated');
    }, 5000);
  }

  window.swinger = {
    ...window.swinger,
    navigation: {
      isBackOrReloadNavigation,
    },
  };
})();
